export const Photourl = ()=>{
   const photourl =  "https://api.csimarital.in/storage"
   return {photourl}
}